import i18n from "i18next";

import type { CellValue } from "../Table/types/types";
import type { TagVariant } from "../Tag/TagStyle";
import { TagStyle } from "../Tag/TagStyle";

interface CellColorBadgeProps {
    cellValue: CellValue;
}

const getOrgUnitStyleVariant = (cellValue: CellValue): TagVariant => {
    switch (cellValue) {
        case "ACTIVE":
            return "heroGreen";
        case "NOT_ACTIVE":
            return "lightPink";
        default:
            return "palePink";
    }
};

const getOrgUnitLabel = (cellValue: CellValue): string | null => {
    switch (cellValue) {
        case "ACTIVE":
            return i18n.t("enum.orgUnitStatus.active");
        case "NOT_ACTIVE":
            return i18n.t("enum.orgUnitStatus.notActive");
        case "DEALER_CHANGE":
            return i18n.t("enum.orgUnitStatus.dealerChange");
        case "ACTIVE_IN_FUTURE":
            return i18n.t("enum.orgUnitStatus.activeInFuture");
        case "INACTIVE_IN_FUTURE":
            return i18n.t("enum.orgUnitStatus.inactiveInFuture");
        default:
            return null;
    }
};

export const HtmlOrgUnitStatusColorBadgeComponent = ({ cellValue }: CellColorBadgeProps) => {
    if (cellValue === null || cellValue === undefined) {
        return null;
    }

    const label = getOrgUnitLabel(cellValue);
    if (label === null) {
        return null;
    }

    return <TagStyle $variant={getOrgUnitStyleVariant(cellValue)}>{label}</TagStyle>;
};
